import {
  PAYOFF_CALLABILITY_AMOUNT_STEP_SIZE,
  PAYOFF_CALLABILITY_AMOUNT_TYPE,
} from './product-capture-field-selectors.consts';

import { FCSelector } from '../../model/form-config.interface';

export const CALL_EVENT_AMOUNT_TYPE: FCSelector = {
  formControlNames: [PAYOFF_CALLABILITY_AMOUNT_TYPE],
  options: [
    {
      id: 'FLAT',
      label: 'Flat',
      effects: [
        {
          formControlNames: [PAYOFF_CALLABILITY_AMOUNT_STEP_SIZE],
          hidden: true,
        },
      ],
    },
    {
      id: 'STEPPED',
      label: 'Stepped',
      effects: [
        {
          formControlNames: [PAYOFF_CALLABILITY_AMOUNT_STEP_SIZE],
          hidden: false,
        },
      ],
    },
    {
      id: null,
      effects: [
        {
          formControlNames: [PAYOFF_CALLABILITY_AMOUNT_STEP_SIZE],
          hidden: true,
        },
      ],
    },
  ],
};
